/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');
const ControlMixin = require('../../mixins/ControlMixin.jsx');

const Config = require('../../configs/Config.js');

const Locked = React.createClass({
    mixins: [ControlMixin],

    render() {
        let part = this.props.parts[0];

        let s3url = Config.images.s3url;

        let hasImage = !!_.get(part, 'metadata.StaticImage');
        let partImage = hasImage ? <img alt={this.displayPartName(part)} src={s3url + _.get(part, 'metadata.StaticImage')} /> : null;

        let displayPart = null;
        if (!partImage) {
            displayPart = 'Design: ' + this.displayPartName(part);
        }

        return (
            <div className="uc-control">
            {displayPart}
            {partImage}
            </div>
        );
    }
});

module.exports = Locked;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/Locked.jsx